import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageData } from "components/pages/TransfersPage";
import Classes, { Account } from "model";

export default function CaptureLoanTransferToSelected(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const loanAccount = Account.getDefaultBrandedAccountByType("loan");
    
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], loanAccount)
        .submit();

    return <TransfersPage data={ data } />
}